
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createTemplateFieldAllowedValueMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateFieldId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"templateFieldValueId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowedValue"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTemplateFieldAllowedValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"templateFieldId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateFieldId"}}},{"kind":"Argument","name":{"kind":"Name","value":"templateFieldValueId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"templateFieldValueId"}}},{"kind":"Argument","name":{"kind":"Name","value":"allowedValue"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowedValue"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"templateFieldAllowedValue"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"client"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"client"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"templateField"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"templateField"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"templateFieldValue"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"templateFieldValue"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":636}};
    doc.loc.source = {"body":"#import '../fragments/template-field-allowed-value'\n#import '../fragments/client'\n#import '../fragments/template-field'\n#import '../fragments/template-field-value'\n\nmutation createTemplateFieldAllowedValueMutation (\n  $templateFieldId: ID\n  $templateFieldValueId: ID\n  $allowedValue: String\n) {\n  createTemplateFieldAllowedValue (\n    templateFieldId: $templateFieldId\n    templateFieldValueId: $templateFieldValueId\n    allowedValue: $allowedValue\n  ) {\n    ...templateFieldAllowedValue\n    client {\n      ...client\n    }\n    templateField {\n      ...templateField\n    }\n    templateFieldValue {\n      ...templateFieldValue\n    }\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('../fragments/template-field-allowed-value').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/client').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/template-field').definitions));
doc.definitions = doc.definitions.concat(unique(require('../fragments/template-field-value').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["createTemplateFieldAllowedValueMutation"] = oneQuery(doc, "createTemplateFieldAllowedValueMutation");
        
